import React, { useEffect,useState } from 'react'
import mondaySdk from "monday-sdk-js";
import noSubscription from '../assets/subscriptionNot.png';
const monday = mondaySdk();

export default function SubscriptionPage() {
    const center= {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "10px",
        padding:"90px",
        height:"300px"
    }
    const styles = {
        button: {
            backgroundColor: "#0073ea", // Monday blue
            color: "#ffffff",
            border: "none",
            borderRadius: "8px",
            padding: "10px 16px",
            fontSize: "14px",
            fontWeight: "500",
            cursor: "pointer",
            transition: "all 0.2s ease-in-out"
        }
    };


    const appPage=()=>{
        monday.execute('openPlanSelection', {isInPlanSelection: true});
    }

  return (
    <div>
        <div style={center}>
            <img src={noSubscription} alt="No Subscription"/>
            <br/>
            <h3>Your app subscription has ended</h3>
            <button
                style={styles.button}
                onClick={appPage}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#0060c0")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#0073ea")}
            >
            See Plans
            </button>
        </div>
    </div>
  )
}
